exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a[data-v-1f66b0d0]:not(.md-button):not(.md-bottom-bar-item):hover{text-decoration:none!important}.tableMain[data-v-1f66b0d0] td{vertical-align:middle!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f66b0d0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/consoleBooking/bookingApprovalLogs.vue
// module id = 1425
// module chunks = 0